import { getRequest, postRequest } from ".";
import apiEndpoints from "./apiEndpoints";

export const getFileFilters = () => getRequest(apiEndpoints.fileTags.filters);
export const getAllTags = () => getRequest(apiEndpoints.tags.allTags);
export const createTagRequest = (payload) =>
  postRequest(apiEndpoints.fileTags.filters, payload);
